import axios from '@/utils/request-manage'

export const mockLogin = (data) => {
  return axios.post('/demo-login', data, {})
}

export const getUserInfo = () => {
  return axios.get('/user/info')
}

export const getAuthCode = () => {
  return axios.get('/authcode')
}

// 二维码登录
export const loginByAuthCode = (authCode) => {
  return axios.post(`/login-by-qrcode?authCode=${authCode}`)
}
